"use client";

import { useEffect, useState } from "react";
import DtvGlobalHeader from "@directv-digital/dds.ui.global-header-v3";
import { useUserRecognition } from "hooks/useRecognizedUserData";

export default function GlobalHeader(props) {
  const [headerData, setHeaderData] = useState(props.data);
  const [disableAuxNav, setDisableAuxNav] = useState(
    props.recognizedUserData ? true : props.disableAuxNav
  );

  const { clientSideIsUserAuthenticated, clientSideIsRecognized } =
    useUserRecognition({
      initialRecognizedUserData: props?.initialRecognizedUserData,
      isUserAuthenticated: props?.isUserAuthenticated
    });

  useEffect(() => {
    if (!clientSideIsUserAuthenticated && !clientSideIsRecognized) {
      return;
    }

    setHeaderData(prev => {
      if (!prev) {
        return prev;
      }
      const source = props?.isRecognizedPage ?
        clientSideIsUserAuthenticated ?
          null :
          clientSideIsRecognized ?
            prev.recog :
            null :
        clientSideIsUserAuthenticated ?
          prev.auth :
          clientSideIsRecognized ?
            prev.recog :
            null;

      if (!source) {
        return prev;
      }

      if (props?.isRecognizedPage) {
        return {
          ...prev,
          auth: {
            ...prev.auth,
            right: source?.right || [],
            mobileHead: source?.mobileHead || []
          }
        };
      }

      return {
        ...prev,
        unauth: {
          ...prev.unauth,
          right: source.right || [],
          mobileHead: source.mobileHead || []
        }
      };
    });
  }, [clientSideIsUserAuthenticated, clientSideIsRecognized]);

  useEffect(() => {
    if (clientSideIsUserAuthenticated) {
      setDisableAuxNav(true);
      return;
    }

    if (!clientSideIsUserAuthenticated && !clientSideIsRecognized) {
      setDisableAuxNav(props.recognizedUserData ? true : props.disableAuxNav);
      return;
    }

    // recognized header falls back to default disable behavior
    setDisableAuxNav(props.recognizedUserData ? true : props.disableAuxNav);
  }, [
    clientSideIsUserAuthenticated,
    clientSideIsRecognized,
    props.disableAuxNav,
    props.recognizedUserData
  ]);

  return (
    <DtvGlobalHeader
      {...props}
      data={headerData}
      disableAuxNav={disableAuxNav}
    />
  );
}
